import React from 'react';
import { Droppable as RBDroppable, DroppableProvided } from '@hello-pangea/dnd';

import colors from '@atom/styles/colors';

interface Props {
  droppableId: string;
  type?: string;
  className?: string;
  style?: React.CSSProperties;
  isDropDisabled?: boolean;
  children: React.ReactNode;
}

export const Droppable = ({
  droppableId,
  type,
  isDropDisabled = false,
  className,
  style,
  children,
}: Props) => {
  return (
    <RBDroppable
      droppableId={droppableId}
      isDropDisabled={isDropDisabled}
      type={type}
    >
      {(provided: DroppableProvided) => (
        <div
          ref={provided.innerRef}
          className={className}
          style={{ background: colors.neutral.white, ...style }}
          {...provided.droppableProps}
        >
          {children}
          {provided.placeholder}
        </div>
      )}
    </RBDroppable>
  );
};
